import { DsIcon } from '@ice-web-app/designSystem';
import { loadModuleNamespace } from '@ice-web-app/shared-i18n';
import { useGlobalStore, useSidebarStore } from '@ice-web-app/shared-store';
import { getCurrentEcosystemBasePath } from '@ice-web-app/shared-utils';
import { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { satV2AR, satV2DE, satV2EN } from '../locales';
import { ZoneRoutes } from '../routes/ZoneRoutes';
import { routes } from '../routes/routes';
import {
  HiOfficeBuilding,
  HiBookOpen,
  HiUserGroup,
  HiClock,
  HiCog,
  HiExclamation,
  HiEye,
  HiAdjustments,
} from 'react-icons/hi';

export const SatV2Zone: FC = () => {
  const { setMenuItems, setEntityMenuItems, setShowEntityMenu, setBackPath } = useSidebarStore();
  const { setShowMainSidebar } = useGlobalStore();
  const showMainSidebar = localStorage.getItem('showMainSidebar') === 'true';
  const location = useLocation();

  useEffect(() => {
    setShowMainSidebar(showMainSidebar);
  }, [showMainSidebar]);

  // Check if we are on an entity route
  useEffect(() => {
    const isEntityRoute = location.pathname.includes('/entity/');
    const entityIdMatch = location.pathname.match(/\/entity\/([^/]+)\//);
    const entityId = entityIdMatch ? entityIdMatch[1] : null;

    if (isEntityRoute && entityId) {
      // Show entity menu
      setShowEntityMenu(true);
      setEntityMenuItems([]);
    } else {
      // Show regular menu
      setShowEntityMenu(false);
      setEntityMenuItems([]);
    }
  }, [location.pathname]);

  useEffect(() => {
    setBackPath(getCurrentEcosystemBasePath() || '/');

    setMenuItems([
      {
        title: 'School Structure',
        icon: <HiOfficeBuilding size={20} />,
        path: routes.schoolStructure,
      },
      {
        title: 'Curriculum Management',
        icon: <HiBookOpen size={20} />,
        path: routes.curriculumManagement,
      },
      {
        title: 'People Management',
        icon: <HiUserGroup size={20} />,
        path: routes.peopleManagement,
      },
      {
        title: 'Timetable Configuration',
        icon: <HiClock size={20} />,
        path: routes.timetableConfiguration,
      },
      {
        title: 'Schedule Generation',
        icon: <HiCog size={20} />,
        path: routes.scheduleGeneration,
      },
      {
        title: 'Conflict Resolution',
        icon: <HiExclamation size={20} />,
        path: routes.conflictResolution,
      },
      {
        title: 'Views & Distribution',
        icon: <HiEye size={20} />,
        path: routes.viewsDistribution,
      },
      {
        title: 'Rules & Constraints',
        icon: <HiAdjustments size={20} />,
        path: routes.rulesConstraints,
      },
    ]);

    return () => {
      setBackPath('');
    };
  }, []);

  useEffect(() => {
    loadModuleNamespace('satV2Zone', [
      { jsonFile: satV2AR, lang: 'ar' },
      { jsonFile: satV2DE, lang: 'de' },
      { jsonFile: satV2EN, lang: 'en' },
    ]);
  }, []);

  return <ZoneRoutes />;
};
export default SatV2Zone;
